import { render, staticRenderFns } from "./ModalForgotPassword.vue?vue&type=template&id=37c703d8&"
import script from "./ModalForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports